export const dbFields =
{
    imei: {
        visiable: false,
        title: 'IMEI',
        key: 'imei'
    },

    curef: {
        visiable: true,
        title: 'CU Ref',
        key: 'curef'
    },
    brand: {
        visiable: true,
        title: 'Brand',
        key: 'brand'
    },
    next_pay_dl: {
        visiable: true,
        title: 'NextPayDate',
        key: 'next_pay_dl_to_date'
    },
    model: {
        visiable: true,
        title: 'Model',
        key: 'model'
    },
};
